var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"no-underline inline-flex logo-text__wrapper",attrs:{"to":"/","title":"Home Page"}},[_c('img',{staticClass:"logo-image",class:{'-inverted': _vm.invert},attrs:{"src":require("../assets/cm-logo.png"),"width":_vm.width,"height":_vm.height,"alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }